import { createContext } from "react";

const ContactosContext = createContext();

export default ContactosContext;
